import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import BaseButton from "../components/BaseButton/BaseButton";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "../components/Modal/Modal";
import MobileModal from "../components/MobileModal/MobileModal";
import Password from "../components/Password/Password";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import logoutIcon from "../images/logout_icon.svg";
import accountIconMobile from "../images/mobile_account_icon.svg";
import loadingIcon from "../images/zee_remote_icon_loading2.svg";
import baseURL from "../baseURL";
import { Fragment } from "react";

const Account = (props) => {
  const [loadingSubmitName, setLoadingSubmitName] = useState(false);
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [loadingLogout, setLoadingLogout] = useState(false);
  const [successLogout, setSuccessLogout] = useState(false);
  const [errorLogout, setErrorLogout] = useState(false);
  const [loadingVerifyEmail, setLoadingVerifyEmail] = useState(false);
  const [successVerifyEmail, setSuccessVerifyEmail] = useState(false);
  const [errorVerifyEmail, setErrorVerifyEmail] = useState(false);
  const [loadingChangeEmail, setLoadingChangeEmail] = useState(false);
  const [successChangeEmail, setSuccessChangeEmail] = useState(false);
  const [errorChangeEmail, setErrorChangeEmail] = useState(false);
  const [errorPwSubmit, setErrorPwSubmit] = useState(false);
  const [loadingPwSubmit, setLoadingPwSubmit] = useState(false);
  const [successPwSubmit, setSuccessPwSubmit] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [tooltipShow, setTooltipShow] = useState(false);
  const [isModalEmail, setIsModalEmail] = useState(false);
  const [isModalVerify, setIsModalVerify] = useState(false);
  const [isModalPw, setIsModalPw] = useState(false);
  const [userArr, setUserArr] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [initFirstName, setInitFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [initLastName, setInitLastName] = useState("");
  const [email, setEmail] = useState("");
  const [initEmail, setInitEmail] = useState("");
  const [emailErrMsg, setEmailErrMsg] = useState("");
  const [emailModal, setEmailModal] = useState("");
  const [emailEditDisabled, setEmailEditDisabled] = useState(true);
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [pwEditDisabled, setPwEditDisabled] = useState(true);
  const [submitNameIsDisabled, setSubmitNameIsDisabled] = useState(true);
  const [errMsg, setErrMsg] = useState("");
  const [accountToken, setAccountToken] = useState("");
  const [tempToken, setTempToken] = useState(null);
  const [pwChangeIsValid, setPwChangeIsValid] = useState(false);
  const [saveErrMsg, setSaveErrMsg] = useState("");
  // Mobile Modal
  const [showMobileModalEmail, setShowMobileModalEmail] = useState(false);
  const [showMobileModalVerify, setShowMobileModalVerify] = useState(false);
  const [showMobileModalPw, setShowMobileModalPw] = useState(false);
  // ENTSOE
  const [entsoeSource, setEntsoeSource] = useState("no_price");
  const [loadingSubmitPricing, setLoadingSubmitPricing] = useState(false);
  const [successSubmitPricing, setSuccessSubmitPricing] = useState(false);
  const [errorSubmitPricing, setErrorSubmitPricing] = useState(false);

  const copyTarget = useRef(null);
  const history = useHistory();

  const SITE_KEY = "6Lei5xsfAAAAAOJ8LN47N0XTDMVFGio3eg47mDCL";

  const token =
    tempToken ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("token");
  const userId =
    localStorage.getItem("userId") || sessionStorage.getItem("userId");

  useEffect(() => {
    if (props.loaded === true) {
      getUserData();
    }
    if (props.loaded === false) {
      setSaveErrMsg("Failed to get account info. Please refresh to try again.");
    }
  }, [props.loaded]);

  const getUserData = async () => {
    try {
      const head = new Headers();
      head.append("Authorization", "Bearer " + token);

      const url = props.userIdAdminOverride
        ? new URL(`./api/v1/users/${props.userIdAdminOverride}`, baseURL)
        : new URL("./api/v1/user/me", baseURL);

      const response = await fetch(url, {
        method: "GET",
        headers: head,
      });

      if (response.ok) {
        let data = await response.json();
        setUserArr(data);
        setFirstName(data.first_name);
        setInitFirstName(data.first_name);
        setLastName(data.last_name);
        setInitLastName(data.last_name);
        setEmail(data.email);
        setInitEmail(data.email);
        setEntsoeSource(data.price_country || "no_price");
        props.userIdAdminOverride || (data.is_verified && data.is_subscribed)
          ? setAccountToken(data.access_token)
          : setAccountToken("Subscribe to SmartZee!");
        setEmailModal(data.email);
      } else {
        history.push("/");
      }
    } catch (error) {
      setSaveErrMsg("Failed to get account info. Please refresh to try again.");
      console.log(error);
    }
  };

  const handleLogoutSubmit = (e) => {
    setLoadingLogout(true);
    setErrorLogout(false);
    setSuccessLogout(false);
    setTimeout(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userId");
      props.setToken("");
      props.setAuthenticated(false);
      history.push("/");
    }, 2000);
  };

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess("Copied!");
      setTooltipShow(true);
      setTimeout(() => {
        setTooltipShow(false);
      }, 1000);
    } catch (error) {
      setCopySuccess("Failed to copy!");
    }
  };

  const handleCloseModalEmail = () => {
    !props.isMobile
      ? setIsModalEmail(!isModalEmail)
      : setShowMobileModalEmail(false);
    setEmailErrMsg("");
    setErrMsg("");
    setSuccessChangeEmail(false);
    setEmailEditDisabled(true);
  };

  const handleCloseModalVerify = () => {
    !props.isMobile
      ? setIsModalVerify(!isModalVerify)
      : setShowMobileModalVerify(false);
  };

  const handleCloseModalPw = () => {
    !props.isMobile ? setIsModalPw(!isModalPw) : setShowMobileModalPw(false);
  };

  const handleFirstNameOnChange = (e) => {
    setFirstName(e.target.value);
    if (e.target.value.length > 20) {
      setSaveErrMsg("Name cannot exceed 20 characters!");
      setSubmitNameIsDisabled(true);
    } else {
      setSubmitNameIsDisabled(false);
      setSaveErrMsg("");
    }

    if (initFirstName === e.target.value) {
      setSaveErrMsg("Name is not changed!");
      setSubmitNameIsDisabled(true);
    }
  };

  const handleLastNameOnChange = (e) => {
    setLastName(e.target.value);
    if (e.target.value.length > 20) {
      setSaveErrMsg("Name cannot exceed 20 characters!");
      setSubmitNameIsDisabled(true);
    } else {
      setSubmitNameIsDisabled(false);
      setSaveErrMsg("");
    }

    if (initLastName === e.target.value) {
      setSaveErrMsg("Name is not changed!");
      setSubmitNameIsDisabled(true);
    }
  };

  const removeWhitespace = (string) => {
    return string.replace(" ", "");
  };

  const handleEmailOnChange = (e) => {
    setEmailModal(e.target.value);
    let emailValidate =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    if (!emailValidate.test(e.target.value)) {
      setEmailErrMsg("Please enter a valid email!");
      setEmailEditDisabled(true);
    } else {
      setEmailEditDisabled(false);
      setEmailErrMsg("");
    }

    if (initEmail === e.target.value) {
      setEmailErrMsg("Email is not changed!");
    }
  };

  const getFreshToken = (loading, success, error, action, actionFn) => {
    loading(true);
    success(false);
    error(false);

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: action })
        .then((accessToken) => {
          actionFn(accessToken);
        });
    });
  };

  const handleSaveName = async (accessToken) => {
    try {
      const url = props.userIdAdminOverride
        ? new URL(`./api/v1/users/${props.userIdAdminOverride}`, baseURL)
        : new URL("./api/v1/user/me/change", baseURL);

      const response = await fetch(url, {
        method: props.userIdAdminOverride ? "PATCH" : "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name: firstName,
          last_name: lastName,
          // price_country: entsoeSource,
          recaptcha: accessToken,
        }),
      });
      if (!response.ok) {
        setLoadingSubmitName(false);
        setErrorSubmit(true);
        setTimeout(() => {
          setErrorSubmit(false);
          setSaveErrMsg("");
        }, 3000);
      } else {
        setLoadingSubmitName(false);
        setSuccessSubmit(true);
        setInitFirstName(firstName);
        setInitLastName(lastName);
        // Set new app-in-app navbar username only if admin has changed name
        props.userIdAdminOverride &&
          props.setSelEmailToRunApp(firstName || email);
        setTimeout(() => {
          setSuccessSubmit(false);
          setErrorSubmit(false);
          setSubmitNameIsDisabled(true);
        }, 5000);
      }
    } catch (error) {
      setLoadingSubmitName(false);
      setErrorSubmit(true);
      setTimeout(() => {
        setErrorSubmit(false);
      }, 3000);
      console.log(error);
    }
  };

  const handleSaveAccount = async () => {
    setLoadingSubmitName(true);
    setErrorSubmit(false);
    setSuccessSubmit(false);
    setSaveErrMsg("");

    try {
      const url = new URL(
        `./api/v1/users/${props.userIdAdminOverride || userId}`,
        baseURL
      );

      const response =
        newPw && newPw !== "" && pwChangeIsValid
          ? await fetch(url, {
              method: "PATCH",
              headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                first_name: firstName,
                last_name: lastName,
                email: email,
                password: newPw,
              }),
            })
          : await fetch(url, {
              method: "PATCH",
              headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                first_name: firstName,
                last_name: lastName,
                email: email,
              }),
            });
      if (!response.ok) {
        setLoadingSubmitName(false);
        setErrorSubmit(true);

        let result = await response.json();

        const breakText = (arr) =>
          arr.map((item, index) => (
            <span key={index}>
              {item && <br />}
              {item}
            </span>
          ));
        if (result.non_field_errors) {
          let message = result.non_field_errors[0];
          let messageArr = message.split("|");
          const lines = breakText(messageArr);
          setSaveErrMsg(lines);
        }
        if (result.password) {
          let message = result.password[0];
          let messageArr = message.split("|");
          const lines = breakText(messageArr);
          setSaveErrMsg(lines);
        }
        setTimeout(() => {
          setErrorSubmit(false);
          setSaveErrMsg("");
        }, 3000);
        // alert("Failed to save settings! Check your connection and try again.");
      } else {
        setLoadingSubmitName(false);
        setSuccessSubmit(true);
        setSaveErrMsg("");
        setTimeout(() => {
          setSuccessSubmit(false);
          setErrorSubmit(false);
          setSubmitNameIsDisabled(true);
        }, 5000);
        // Seems no need for that
        // setTimeout(() => {
        //   newPw && newPw !== "" && window.location.reload();
        // }, 500);
        setInitFirstName(firstName);
        setInitEmail(email);
      }
    } catch (error) {
      setLoadingSubmitName(false);
      setErrorSubmit(true);
      setTimeout(() => {
        setErrorSubmit(false);
      }, 3000);
      console.log(error);
      // alert("Failed to save settings! Check your connection and try again.");
    }
  };

  const handleSaveEmail = async (accessToken) => {
    try {
      const url = props.userIdAdminOverride
        ? new URL(`./api/v1/users/${props.userIdAdminOverride}`, baseURL)
        : new URL("./api/v1/accounts/email/change", baseURL);

      const response = await fetch(url, {
        method: props.userIdAdminOverride ? "PATCH" : "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: emailModal,
          recaptcha: accessToken,
        }),
      });

      let result = await response.json();

      if (!response.ok) {
        result.detail && setErrMsg(result.detail);
        setLoadingChangeEmail(false);
        setErrorChangeEmail(true);
        setTimeout(() => {
          setErrorChangeEmail(false);
          setErrMsg("");
        }, 3000);
      } else {
        setLoadingChangeEmail(false);
        setSuccessChangeEmail(true);
        setEmailEditDisabled(true);
        // Set new email instantly only if admin has changed email
        props.userIdAdminOverride && setEmail(emailModal);
        // Set new app-in-app navbar username only if admin has changed name
        props.userIdAdminOverride &&
          props.setSelEmailToRunApp(firstName || emailModal);
      }
    } catch (error) {
      setLoadingChangeEmail(false);
      setErrorChangeEmail(true);
      setTimeout(() => {
        setErrorChangeEmail(false);
      }, 3000);
      console.log(error);
    }
  };

  const handleSavePw = async (accessToken) => {
    try {
      const url = props.userIdAdminOverride
        ? new URL(`./api/v1/users/${props.userIdAdminOverride}`, baseURL)
        : new URL("./api/v1/accounts/password/change", baseURL);

      const response = await fetch(url, {
        method: props.userIdAdminOverride ? "PATCH" : "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: newPw,
          recaptcha: accessToken,
        }),
      });

      let result = await response.json();

      if (!response.ok) {
        result.password && setErrMsg("Password is too weak!");
        setLoadingPwSubmit(false);
        setErrorPwSubmit(true);
        setTimeout(() => {
          setErrorPwSubmit(false);
          setErrMsg("");
        }, 3000);
      } else {
        setLoadingPwSubmit(false);
        setSuccessPwSubmit(true);
        setTimeout(() => {
          handleCloseModalPw();
          setSaveErrMsg("Password changed successfully!");
        }, 1000);
      }
    } catch (error) {
      setLoadingPwSubmit(false);
      setErrorPwSubmit(true);
      setTimeout(() => {
        setErrorPwSubmit(false);
      }, 3000);
      console.log(error);
    }
  };

  const handleTryLogin = async (accessToken) => {
    try {
      const url = new URL("./auth/login", baseURL);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: props.userIdAdminOverride ? props.adminEmail : email,
          password: oldPw,
          recaptcha: accessToken,
        }),
      });

      if (!response.ok) {
        setErrMsg(
          `Incorrect ${props.userIdAdminOverride ? "admin" : "old"} password!`
        );
        setLoadingPwSubmit(false);
        setErrorPwSubmit(true);
        setTimeout(() => {
          setErrorPwSubmit(false);
          setErrMsg("");
        }, 3000);
      } else {
        // let temp_token = result.access;
        // handleSavePw(temp_token);
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(SITE_KEY, { action: "password_change" })
            .then((accessToken) => {
              handleSavePw(accessToken);
            });
        });
      }
    } catch (error) {
      setLoadingPwSubmit(false);
      setErrorPwSubmit(true);
      setTimeout(() => {
        setErrorPwSubmit(false);
      }, 3000);
      console.log(error);
    }
  };

  const sendVerificationEmail = async () => {
    setLoadingVerifyEmail(true);

    try {
      const head = new Headers();
      head.append("Authorization", "Bearer " + token);

      const url = new URL("./api/v1/accounts/signup/resend", baseURL);

      const response = await fetch(url, {
        method: "GET",
        headers: head,
      });

      let result = await response.json();

      if (!response.ok) {
        result.detail && setErrMsg(result.detail);
        setLoadingVerifyEmail(false);
        setErrorVerifyEmail(true);
        setTimeout(() => {
          setErrorVerifyEmail(false);
          setErrMsg("");
        }, 3000);
      } else {
        setLoadingVerifyEmail(false);
        setSuccessVerifyEmail(true);
        setErrMsg("Email sent! Please check your inbox.");
        setTimeout(() => {
          setSuccessVerifyEmail(false);
          setErrorVerifyEmail(false);
          setErrMsg("");
        }, 5000);
      }
    } catch (error) {
      setLoadingVerifyEmail(false);
      setErrorVerifyEmail(true);
      setTimeout(() => {
        setErrorVerifyEmail(false);
      }, 3000);
      console.log(error);
    }
  };

  const getOldPwFromChild = (pw) => {
    setOldPw(pw);
  };

  const handleChangeENTSOEPricingOld = () => {
    alert(
      "Selected ENTSOE country is: " +
        entsoeSource[0].toUpperCase() +
        entsoeSource.substring(1)
    );
  };

  const handleSavePricing = async (accessToken) => {
    try {
      const url = props.userIdAdminOverride
        ? new URL(`./api/v1/users/${props.userIdAdminOverride}`, baseURL)
        : new URL("./api/v1/user/me/change", baseURL);

      const response = await fetch(url, {
        method: props.userIdAdminOverride ? "PATCH" : "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // first_name: firstName,
          // last_name: lastName,
          price_country: entsoeSource,
          recaptcha: accessToken,
        }),
      });
      if (!response.ok) {
        setLoadingSubmitPricing(false);
        setErrorSubmitPricing(true);
        setTimeout(() => {
          setErrorSubmitPricing(false);
        }, 3000);
      } else {
        setLoadingSubmitPricing(false);
        setSuccessSubmitPricing(true);
        // Set new app-in-app navbar username only if admin has changed name
        props.userIdAdminOverride &&
          props.setSelEmailToRunApp(firstName || email);
        setTimeout(() => {
          setSuccessSubmitPricing(false);
          setErrorSubmitPricing(false);
        }, 5000);
      }
    } catch (error) {
      setLoadingSubmitPricing(false);
      setErrorSubmitPricing(true);
      setTimeout(() => {
        setErrorSubmitPricing(false);
      }, 3000);
      console.log(error);
    }
  };

  const JSXContentChangeEmail = (
    <Fragment>
      <div
        id='modal-content-wrapper'
        className='is-fluid'
        style={{ width: "100%" }}>
        <div className='columns '>
          <div className='column flex-start'>
            <label className='label'>Email</label>
          </div>
          <div className='column'>
            <input
              id='account-email-edit-modal-email-input'
              className='input email-input'
              type='text'
              disabled={false}
              onChange={handleEmailOnChange}
              value={emailModal}
            />
          </div>
          <div className='column'>
            <div className='input-err-msg-wrapper'>
              <p
                id='account-email-edit-modal-email-err-msg'
                className='email-err-msg m-0'
                style={{
                  fontSize: "11px",
                  color: "red",
                  textAlign: "left",
                }}>
                {emailErrMsg}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );

  const JSXContentChangeEmailSuccess = (
    <div
      id='modal-content-wrapper'
      className='is-fluid'
      style={{ width: "100%" }}>
      {!props.userIdAdminOverride ? (
        <div className='email-change-success'>
          <span>Email change requested successfully!</span>
          <span style={{ display: "block", marginTop: "10px" }}>
            A confirmation email has been sent to your new email:
          </span>
          <span className='email-change-user-email-span'>{emailModal}</span>.
          <span style={{ display: "inline-block", marginTop: "10px" }}>
            However, you need to click on the link inside the confirmation email
            in order to approve the change. If you can't find it in your Inbox,
            please check Spam / Junk folder.
          </span>
        </div>
      ) : (
        <div style={{ textAlign: "left" }}>
          Email successfully changed! However, new email will need to be
          verified by the user.
        </div>
      )}
    </div>
  );

  const JSXContentVerifyEmail = (
    <span>Click Send button to send verification email</span>
  );

  const JSXContentChangePw = (
    <Password
      setPwEditDisabled={setPwEditDisabled}
      setNewPw={setNewPw}
      isModalPw={isModalPw}
      showMobileModal={showMobileModalPw}
      getOldPwFromChild={getOldPwFromChild}
      userIdAdminOverride={props.userIdAdminOverride}
    />
  );

  return (
    <div
      id='account-page'
      className='container'
      style={{
        height: "calc(100vh - 140px)",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}>
      {!props.userIdAdminOverride && (
        <Fragment>
          <div className='account-logout-btn-wrapper'>
            <BaseButton
              id='account-logout-btn'
              classes='px-6 has-text-weight-semibold '
              onClick={handleLogoutSubmit}
              display={true}
              displayIcon={logoutIcon}
              text='LOGOUT'
              loading={loadingLogout}
              error={errorLogout}
              success={successLogout}
            />
          </div>
          <div className='account-logout-btn-wrapper account-logout-btn-wrapper-mobile'>
            <BaseButton
              id='account-logout-btn-mobile'
              classes='px-6 has-text-weight-semibold account-logout-btn'
              onClick={handleLogoutSubmit}
              display={true}
              displayIcon={logoutIcon}
              loading={loadingLogout}
              error={errorLogout}
              success={successLogout}
            />
          </div>
        </Fragment>
      )}
      <div className='account-title-wrapper'>
        <img
          className='account_divider-circle-mobile'
          src={accountIconMobile}
          alt='account icon'
        />
        <h6 className='home-title'>ACCOUNT SETTINGS</h6>
      </div>
      <div className='columns auth-wrapper account-wrapper'>
        <div className='column is-half account_user-form'>
          <p className='account-p-title'>
            You can <span className='underlined'>edit</span> your personal
            account information
          </p>
          <p className='account-p-title-dt'>
            You can <span className='underlined'>edit</span> your personal
            account information
          </p>
          <div className='field is-horizontal account-name label-on-top'>
            <div
              className='field-label pt-3 pb-2'
              style={{
                flexBasis: "auto",
                flexGrow: "unset",
              }}>
              <label className='label'>First Name</label>
            </div>
            <div className='field-body'>
              <div className='field'>
                <div className='control is-expanded'>
                  <input
                    id='account-first-name-input'
                    className='input'
                    type='text'
                    onChange={handleFirstNameOnChange}
                    value={firstName}
                    maxLength='20'
                    disabled={props.isAdminOverride}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='field is-horizontal account-name label-on-top'>
            <div
              className='field-label pt-3 pb-2'
              style={{
                flexBasis: "auto",
                flexGrow: "unset",
              }}>
              <label className='label'>Last Name</label>
            </div>
            <div className='field-body'>
              <div className='field'>
                <div className='control is-expanded'>
                  <input
                    id='account-last-name-input'
                    className='input'
                    type='text'
                    onChange={handleLastNameOnChange}
                    value={lastName}
                    maxLength='20'
                    disabled={props.isAdminOverride}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='field is-horizontal save-changes-btn-container'>
            <div className='field'>
              <div className='field-body'>
                <div
                  className='control is-expanded'
                  style={{ display: "flex" }}>
                  <BaseButton
                    id='account-save-changes-btn'
                    classes='px-6 has-text-weight-semibold save-changes'
                    onClick={() =>
                      getFreshToken(
                        setLoadingSubmitName,
                        setSuccessSubmit,
                        setErrorSubmit,
                        "account",
                        handleSaveName
                      )
                    }
                    text='SAVE CHANGES'
                    disabled={!props.loaded || submitNameIsDisabled}
                    loading={loadingSubmitName}
                    error={errorSubmit}
                    success={successSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='field is-horizontal account-email label-on-top'>
            <div
              className='field-label pt-3 pb-2'
              style={{
                flexBasis: "auto",
                flexGrow: "unset",
              }}>
              <label className='label'>Email</label>
            </div>
            <div className='field-body'>
              <div className='field' style={{ position: "relative" }}>
                <div className='control is-expanded'>
                  <input
                    id='account-email-input'
                    className='input'
                    type='text'
                    disabled={true}
                    defaultValue={email}
                  />
                </div>
                <button
                  id='account-email-edit-btn'
                  className={`btn-small flex-it ${
                    props.isAdminOverride && "disabled"
                  }`}
                  disabled={!props.loaded}
                  onClick={() => {
                    if (!props.isAdminOverride) {
                      props.isMobile
                        ? setShowMobileModalEmail(true)
                        : setIsModalEmail(true);
                      setEmailModal(email);
                    }
                  }}>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 30 30'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M6.05977 23.4375C6.13008 23.4375 6.20039 23.4305 6.2707 23.4199L12.184 22.3828C12.2543 22.3687 12.3211 22.3371 12.3703 22.2844L27.273 7.38164C27.3056 7.34912 27.3315 7.31048 27.3491 7.26795C27.3668 7.22542 27.3759 7.17983 27.3759 7.13379C27.3759 7.08775 27.3668 7.04215 27.3491 6.99962C27.3315 6.95709 27.3056 6.91846 27.273 6.88594L21.4301 1.03945C21.3633 0.972656 21.2754 0.9375 21.1805 0.9375C21.0855 0.9375 20.9977 0.972656 20.9309 1.03945L6.02812 15.9422C5.97539 15.9949 5.94375 16.0582 5.92969 16.1285L4.89258 22.0418C4.85838 22.2301 4.8706 22.424 4.92818 22.6065C4.98576 22.7891 5.08697 22.9548 5.22305 23.0895C5.45508 23.3145 5.74688 23.4375 6.05977 23.4375ZM8.4293 17.3062L21.1805 4.55859L23.7574 7.13555L11.0062 19.8832L7.88086 20.4352L8.4293 17.3062ZM27.9375 26.3906H2.0625C1.44023 26.3906 0.9375 26.8934 0.9375 27.5156V28.7812C0.9375 28.9359 1.06406 29.0625 1.21875 29.0625H28.7812C28.9359 29.0625 29.0625 28.9359 29.0625 28.7812V27.5156C29.0625 26.8934 28.5598 26.3906 27.9375 26.3906Z'
                      fill='#202B33'
                    />
                  </svg>
                </button>
                <Modal
                  title='Change Email'
                  content={
                    successChangeEmail
                      ? JSXContentChangeEmailSuccess
                      : JSXContentChangeEmail
                  }
                  isModal={isModalEmail}
                  handleCloseModal={handleCloseModalEmail}
                  actionFn={() =>
                    getFreshToken(
                      setLoadingChangeEmail,
                      setSuccessChangeEmail,
                      setErrorChangeEmail,
                      "email_change",
                      handleSaveEmail
                    )
                  }
                  actionName='Apply'
                  cancelName={successChangeEmail && "Close"}
                  loading={loadingChangeEmail}
                  success={successChangeEmail}
                  error={errorChangeEmail}
                  errMsg={errMsg}
                  disabled={emailEditDisabled}
                  actionBtnId='account-email-edit-modal-action-btn'
                  cancelBtnId='account-email-edit-modal-cancel-btn'
                />
                <MobileModal
                  title='Change Email'
                  content={
                    successChangeEmail
                      ? JSXContentChangeEmailSuccess
                      : JSXContentChangeEmail
                  }
                  showMobileModal={showMobileModalEmail}
                  setShowMobileModal={setShowMobileModalEmail}
                  handleCloseModal={handleCloseModalEmail}
                  actionFn={() =>
                    getFreshToken(
                      setLoadingChangeEmail,
                      setSuccessChangeEmail,
                      setErrorChangeEmail,
                      "email_change",
                      handleSaveEmail
                    )
                  }
                  actionName='Apply'
                  cancelName={successChangeEmail && "Close"}
                  loading={loadingChangeEmail}
                  success={successChangeEmail}
                  error={errorChangeEmail}
                  errMsg={errMsg}
                  disabled={emailEditDisabled}
                  actionBtnId='account-email-edit-modal-action-btn-mobile'
                  cancelBtnId='account-email-edit-modal-cancel-btn-mobile'
                />
                {/* Email verify button */}
                {props.userIsVerified === false &&
                  !props.userIdAdminOverride && (
                    <OverlayTrigger
                      trigger={["hover", "hover"]}
                      key='right'
                      placement='top'
                      overlay={
                        <Popover id='verify-email-popup'>
                          <Popover.Body>Resend verification email</Popover.Body>
                        </Popover>
                      }
                      rootClose>
                      <button
                        id='account-email-verify-btn'
                        style={{ right: "-140px" }}
                        className={`account-verify-email-desktop btn-small flex-it ${
                          props.isAdminOverride && "disabled"
                        }`}
                        onClick={() => {
                          props.isMobile
                            ? setShowMobileModalVerify(true)
                            : setIsModalVerify(true);
                        }}>
                        <svg
                          width='38'
                          height='19'
                          viewBox='0 0 38 19'
                          fill='none'
                          style={{ position: "relative", left: "-1px" }}
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M5.4043 2.2025C4.67449 2.2025 4.08287 2.79412 4.08287 3.52393C4.08287 4.25373 4.67449 4.84535 5.4043 4.84535V2.2025ZM9.80906 2.2025H5.4043V4.84535H9.80906V2.2025Z'
                            fill='#202B33'
                          />
                          <path
                            d='M3.64258 7.48814C2.91277 7.48814 2.32115 8.07977 2.32115 8.80957C2.32115 9.53938 2.91277 10.131 3.64258 10.131L3.64258 7.48814ZM9.80924 7.48814L3.64258 7.48814L3.64258 10.131L9.80924 10.131V7.48814Z'
                            fill='#202B33'
                          />
                          <path
                            d='M1.88086 12.7738C1.15105 12.7738 0.559431 13.3654 0.559431 14.0952C0.559431 14.825 1.15105 15.4166 1.88086 15.4166L1.88086 12.7738ZM9.80943 12.7738L1.88086 12.7738L1.88086 15.4166L9.80943 15.4166V12.7738Z'
                            fill='#202B33'
                          />
                          <rect
                            x='14.6554'
                            y='1.32143'
                            width='22.0238'
                            height='15.8571'
                            rx='1.32143'
                            stroke='#202B33'
                            stroke-width='2.64286'
                          />
                          <path
                            d='M13.7734 2.64282L25.6663 9.24997L36.6782 2.64282'
                            stroke='#202B33'
                            stroke-width='2.64286'
                          />
                        </svg>
                      </button>
                    </OverlayTrigger>
                  )}
                <Modal
                  title='Send Verification Email'
                  content={JSXContentVerifyEmail}
                  isModal={isModalVerify}
                  handleCloseModal={handleCloseModalVerify}
                  actionFn={sendVerificationEmail}
                  actionName='Send'
                  cancelName={successVerifyEmail && "Close"}
                  loading={loadingVerifyEmail}
                  success={successVerifyEmail}
                  error={errorVerifyEmail}
                  errMsg={errMsg}
                  isSuccess={successVerifyEmail}
                  actionBtnId='account-email-verify-modal-action-btn'
                  cancelBtnId='account-email-verify-modal-cancel-btn'
                />
                <MobileModal
                  title='Send Verification Email'
                  content={JSXContentVerifyEmail}
                  showMobileModal={showMobileModalVerify}
                  setShowMobileModal={setShowMobileModalVerify}
                  handleCloseModal={handleCloseModalVerify}
                  actionFn={sendVerificationEmail}
                  actionName='Send'
                  cancelName={successVerifyEmail && "Close"}
                  loading={loadingVerifyEmail}
                  success={successVerifyEmail}
                  error={errorVerifyEmail}
                  errMsg={errMsg}
                  isSuccess={successVerifyEmail}
                  actionBtnId='account-email-verify-modal-action-btn-mobile'
                  cancelBtnId='account-email-verify-modal-cancel-btn-mobile'
                />
              </div>
            </div>
          </div>
          {/* Email verify button mobile */}
          {props.userIsVerified === false && !props.userIdAdminOverride && (
            <div className='field is-horizontal account-verify-email-mob'>
              <div
                className='field-label pt-3 pb-2'
                style={{
                  flexBasis: "auto",
                  flexGrow: "unset",
                  position: "relative",
                }}>
                <label className='label'>
                  Resend Verification Email
                  <button
                    id='account-email-verify-btn-mobile'
                    className={`btn-small flex-it ${
                      props.isAdminOverride && "disabled"
                    }`}
                    onClick={() => {
                      props.isMobile
                        ? setShowMobileModalVerify(true)
                        : setIsModalVerify(true);
                    }}>
                    <svg
                      width='38'
                      height='19'
                      viewBox='0 0 38 19'
                      fill='none'
                      style={{ position: "relative", left: "-1px" }}
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M5.4043 2.2025C4.67449 2.2025 4.08287 2.79412 4.08287 3.52393C4.08287 4.25373 4.67449 4.84535 5.4043 4.84535V2.2025ZM9.80906 2.2025H5.4043V4.84535H9.80906V2.2025Z'
                        fill='#202B33'
                      />
                      <path
                        d='M3.64258 7.48814C2.91277 7.48814 2.32115 8.07977 2.32115 8.80957C2.32115 9.53938 2.91277 10.131 3.64258 10.131L3.64258 7.48814ZM9.80924 7.48814L3.64258 7.48814L3.64258 10.131L9.80924 10.131V7.48814Z'
                        fill='#202B33'
                      />
                      <path
                        d='M1.88086 12.7738C1.15105 12.7738 0.559431 13.3654 0.559431 14.0952C0.559431 14.825 1.15105 15.4166 1.88086 15.4166L1.88086 12.7738ZM9.80943 12.7738L1.88086 12.7738L1.88086 15.4166L9.80943 15.4166V12.7738Z'
                        fill='#202B33'
                      />
                      <rect
                        x='14.6554'
                        y='1.32143'
                        width='22.0238'
                        height='15.8571'
                        rx='1.32143'
                        stroke='#202B33'
                        stroke-width='2.64286'
                      />
                      <path
                        d='M13.7734 2.64282L25.6663 9.24997L36.6782 2.64282'
                        stroke='#202B33'
                        stroke-width='2.64286'
                      />
                    </svg>
                  </button>
                </label>
              </div>
            </div>
          )}
          <div className='field is-horizontal account-pw label-on-top'>
            <div
              className='field-label pt-3 pb-2'
              style={{
                flexBasis: "auto",
                flexGrow: "unset",
              }}>
              <label className='label'>Password</label>
            </div>
            <div className='field-body'>
              <div className='field' style={{ position: "relative" }}>
                <div className='control is-expanded'>
                  <input
                    id='account-pw-input'
                    className='input'
                    type='password'
                    disabled={true}
                    defaultValue={11111111}
                  />
                </div>
                <button
                  id='account-pw-edit-btn'
                  className={`btn-small flex-it ${
                    props.isAdminOverride && "disabled"
                  }`}
                  disabled={!props.loaded}
                  onClick={() => {
                    if (!props.isAdminOverride) {
                      props.isMobile
                        ? setShowMobileModalPw(true)
                        : setIsModalPw(true);
                      setSuccessPwSubmit(false);
                      setSaveErrMsg("");
                    }
                  }}>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 30 30'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M6.05977 23.4375C6.13008 23.4375 6.20039 23.4305 6.2707 23.4199L12.184 22.3828C12.2543 22.3687 12.3211 22.3371 12.3703 22.2844L27.273 7.38164C27.3056 7.34912 27.3315 7.31048 27.3491 7.26795C27.3668 7.22542 27.3759 7.17983 27.3759 7.13379C27.3759 7.08775 27.3668 7.04215 27.3491 6.99962C27.3315 6.95709 27.3056 6.91846 27.273 6.88594L21.4301 1.03945C21.3633 0.972656 21.2754 0.9375 21.1805 0.9375C21.0855 0.9375 20.9977 0.972656 20.9309 1.03945L6.02812 15.9422C5.97539 15.9949 5.94375 16.0582 5.92969 16.1285L4.89258 22.0418C4.85838 22.2301 4.8706 22.424 4.92818 22.6065C4.98576 22.7891 5.08697 22.9548 5.22305 23.0895C5.45508 23.3145 5.74688 23.4375 6.05977 23.4375ZM8.4293 17.3062L21.1805 4.55859L23.7574 7.13555L11.0062 19.8832L7.88086 20.4352L8.4293 17.3062ZM27.9375 26.3906H2.0625C1.44023 26.3906 0.9375 26.8934 0.9375 27.5156V28.7812C0.9375 28.9359 1.06406 29.0625 1.21875 29.0625H28.7812C28.9359 29.0625 29.0625 28.9359 29.0625 28.7812V27.5156C29.0625 26.8934 28.5598 26.3906 27.9375 26.3906Z'
                      fill='#202B33'
                    />
                  </svg>
                </button>
                <p
                  className='save-changes pw-submit-success'
                  style={{
                    minHeight: "1rem",
                    color: successPwSubmit ? "limegreen" : "red",
                    fontSize: "12px",
                    textAlign: "left",
                    marginTop: "2rem",
                    position: "absolute",
                  }}>
                  {saveErrMsg}
                </p>
                <Modal
                  title='Change Password'
                  isModal={isModalPw}
                  content={JSXContentChangePw}
                  handleCloseModal={handleCloseModalPw}
                  actionFn={() =>
                    getFreshToken(
                      setLoadingPwSubmit,
                      setSuccessPwSubmit,
                      setErrorPwSubmit,
                      "login",
                      handleTryLogin
                    )
                  }
                  actionName='Apply'
                  disabled={pwEditDisabled}
                  loading={loadingPwSubmit}
                  success={successPwSubmit}
                  error={errorPwSubmit}
                  errMsg={errMsg}
                  actionBtnId='account-pw-edit-modal-action-btn'
                  cancelBtnId='account-pw-edit-modal-cancel-btn'
                />
                <MobileModal
                  title='Change Password'
                  showMobileModal={showMobileModalPw}
                  setShowMobileModal={setShowMobileModalPw}
                  content={JSXContentChangePw}
                  handleCloseModal={handleCloseModalPw}
                  actionFn={() =>
                    getFreshToken(
                      setLoadingPwSubmit,
                      setSuccessPwSubmit,
                      setErrorPwSubmit,
                      "login",
                      handleTryLogin
                    )
                  }
                  actionName='Apply'
                  disabled={pwEditDisabled}
                  loading={loadingPwSubmit}
                  success={successPwSubmit}
                  error={errorPwSubmit}
                  errMsg={errMsg}
                  actionBtnId='account-pw-edit-modal-action-btn-mobile'
                  cancelBtnId='account-pw-edit-modal-cancel-btn-mobile'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='account_divider-circle'>
          <svg
            width='144'
            height='762'
            viewBox='0 0 144 762'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <g filter='url(#filter0_d)'>
              <line x1='71.5' y1='-31' x2='71.5' y2='762' stroke='#A4A5AA' />
            </g>
            <circle
              cx='71'
              cy='158'
              r='66'
              fill='#202B33'
              stroke='#A4A5AA'
              strokeWidth='2'
            />
            <path
              d='M72 221.672C86.7243 221.672 100.285 216.665 111.081 208.271L112.46 207.199L111.583 205.688C107.561 198.755 101.786 193.001 94.8386 189.002C87.8914 185.004 80.0155 182.902 72 182.906C63.9845 182.902 56.1086 185.004 49.1614 189.002C42.214 193.001 36.4395 198.755 32.4166 205.688L31.5413 207.197L32.9166 208.269C44.0824 216.976 57.8411 221.694 72 221.672ZM72 221.672V219.672L72.0032 221.672C72.0021 221.672 72.0011 221.672 72 221.672ZM24.9387 200.886L26.6976 202.816L28.1028 200.615C32.8098 193.242 39.2994 187.175 46.9717 182.974C54.644 178.773 63.2515 176.573 71.9987 176.579H72C90.445 176.579 106.651 186.165 115.898 200.617L117.304 202.814L119.061 200.886C127.374 191.764 132.856 180.422 134.841 168.242C136.826 156.061 135.229 143.566 130.243 132.276C125.257 120.987 117.097 111.39 106.757 104.652C96.4169 97.9151 84.3415 94.3281 72.0001 94.3276L72 96.3276L71.9999 94.3276C59.6585 94.3281 47.5831 97.9151 37.2429 104.652C26.9027 111.39 18.7432 120.987 13.7573 132.276C8.77133 143.566 7.17373 156.061 9.15886 168.242C11.144 180.422 16.6262 191.764 24.9387 200.886ZM2 158C2 139.435 9.37498 121.63 22.5025 108.503C35.6301 95.375 53.4348 88 72 88C90.5652 88 108.37 95.375 121.497 108.503C134.625 121.63 142 139.435 142 158C142 176.565 134.625 194.37 121.497 207.497C108.37 220.625 90.5652 228 72 228C53.4348 228 35.6301 220.625 22.5025 207.497C9.37498 194.37 2 176.565 2 158ZM48.4527 147.183C48.4527 140.938 50.9335 134.949 55.3495 130.533C59.7655 126.117 65.7549 123.636 72 123.636C78.2451 123.636 84.2345 126.117 88.6505 130.533C93.0665 134.949 95.5473 140.938 95.5473 147.183C95.5473 153.428 93.0665 159.418 88.6505 163.834C84.2345 168.25 78.2451 170.73 72 170.73C65.7549 170.73 59.7655 168.25 55.3495 163.834C50.9335 159.418 48.4527 153.428 48.4527 147.183ZM72 129.963C69.7387 129.963 67.4995 130.409 65.4103 131.274C63.3211 132.14 61.4228 133.408 59.8238 135.007C58.2248 136.606 56.9565 138.504 56.0911 140.593C55.2257 142.683 54.7803 144.922 54.7803 147.183C54.7803 149.444 55.2257 151.684 56.0911 153.773C56.9565 155.862 58.2248 157.76 59.8238 159.359C61.4228 160.958 63.3211 162.227 65.4103 163.092C67.4995 163.957 69.7387 164.403 72 164.403C76.5669 164.403 80.9468 162.589 84.1762 159.359C87.4055 156.13 89.2197 151.75 89.2197 147.183C89.2197 142.616 87.4055 138.236 84.1762 135.007C80.9468 131.778 76.5669 129.963 72 129.963Z'
              fill='#A4A5AA'
              stroke='#202B33'
              strokeWidth='4'
            />
            <g filter='url(#filter1_d)'>
              <line x1='71.5' y1='85' x2='71.5' y2='92' stroke='#A4A5AA' />
            </g>
            <g filter='url(#filter2_d)'>
              <line x1='71.5' y1='224' x2='71.5' y2='231' stroke='#A4A5AA' />
            </g>
            <defs>
              <filter
                id='filter0_d'
                x='63'
                y='-37'
                width='17'
                height='809'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset dy='2' />
                <feGaussianBlur stdDeviation='4' />
                <feColorMatrix
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
                />
                <feBlend
                  mode='normal'
                  in2='BackgroundImageFix'
                  result='effect1_dropShadow'
                />
                <feBlend
                  mode='normal'
                  in='SourceGraphic'
                  in2='effect1_dropShadow'
                  result='shape'
                />
              </filter>
              <filter
                id='filter1_d'
                x='63'
                y='79'
                width='17'
                height='23'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset dy='2' />
                <feGaussianBlur stdDeviation='4' />
                <feColorMatrix
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
                />
                <feBlend
                  mode='normal'
                  in2='BackgroundImageFix'
                  result='effect1_dropShadow'
                />
                <feBlend
                  mode='normal'
                  in='SourceGraphic'
                  in2='effect1_dropShadow'
                  result='shape'
                />
              </filter>
              <filter
                id='filter2_d'
                x='63'
                y='218'
                width='17'
                height='23'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset dy='2' />
                <feGaussianBlur stdDeviation='4' />
                <feColorMatrix
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
                />
                <feBlend
                  mode='normal'
                  in2='BackgroundImageFix'
                  result='effect1_dropShadow'
                />
                <feBlend
                  mode='normal'
                  in='SourceGraphic'
                  in2='effect1_dropShadow'
                  result='shape'
                />
              </filter>
            </defs>
          </svg>
        </div>
        {/* <div className='divider-line'></div> */}
        <div className='column is-half account_token'>
          <div className='field is-horizontal auth-pw label-on-top'>
            <p className='account-p-title account-p-left account-p-copy'>
              You can <span className='underlined'>copy</span> your unique
              account token ID to setup your new devices
            </p>
            <p className='account-p-title-dt'>
              You can <span className='underlined'>copy</span> your unique
              account token ID to setup your new devices
            </p>
            <div
              className='field-label pt-3 pb-2'
              style={{
                flexBasis: "auto",
                flexGrow: "unset",
              }}>
              <label className='label'>Account Token</label>
            </div>
            <div className='field-body'>
              <div className='field'>
                <div
                  className='control is-expanded'
                  style={{ position: "relative" }}>
                  <input
                    id='account-token-input'
                    className='input'
                    type='text'
                    disabled={true}
                    defaultValue={accountToken}
                  />
                  <button
                    id='account-token-copy-btn'
                    className='btn-small flex-it'
                    ref={copyTarget}
                    disabled={!props.loaded}
                    onClick={() => copyToClipBoard(accountToken)}>
                    <svg
                      width='25'
                      height='31'
                      viewBox='0 0 25 31'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M4.75391 6.49992L6.76008 4.33325H17.6215L24.8156 12.1029V28.1666L22.8095 30.3332H6.76008L4.75391 28.1666V6.49992ZM22.8095 12.9999L16.7909 6.49992H6.76008V28.1666H22.8095V12.9999Z'
                        fill='#202B33'
                      />
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M2.74738 0L0.741211 2.16667V23.8333L2.74738 26V2.16667H15.615L13.6088 0H2.74738Z'
                        fill='#202B33'
                      />
                    </svg>
                  </button>
                  <Overlay
                    target={copyTarget.current}
                    show={tooltipShow}
                    placement='top'>
                    {(props) => (
                      <Tooltip id='copy-tooltip' {...props}>
                        Copied!
                      </Tooltip>
                    )}
                  </Overlay>
                </div>
              </div>
            </div>
          </div>
          <p className='account-p-title account-p-left account-p-pricing'>
            You can <span className='underlined'>set up</span> your ENTSOE
            electricity pricing data source
          </p>
          <div className='field is-horizontal auth-pw label-on-top'>
            <p className='account-p-title-dt'>
              You can <span className='underlined'>set up</span> your ENTSOE
              electricity pricing data source
            </p>
            <div
              className='field-label pt-3 pb-2 pricing-label'
              style={{
                flexBasis: "auto",
                flexGrow: "unset",
              }}>
              <label className='label'>
                <svg
                  width='26'
                  height='26'
                  viewBox='0 0 26 26'
                  fill='none'
                  style={{
                    transform: "scaleX(1.07)",
                    position: "relative",
                    top: "-2px",
                    left: "-2px",
                  }}
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z'
                    stroke='#6F7281'
                  />
                  <path
                    d='M9.73 10C10.688 8.187 12.482 7 14.471 7C15.936 7 17.278 7.632 18.273 8.686C18.457 8.86981 18.7054 8.97469 18.9655 8.97838C19.2256 8.98208 19.4768 8.88431 19.666 8.7058C19.8552 8.5273 19.9674 8.28212 19.9787 8.02227C19.9901 7.76243 19.8998 7.50837 19.727 7.314C18.387 5.894 16.533 5 14.471 5C11.292 5 8.644 7.097 7.545 10H6C5.73478 10 5.48043 10.1054 5.29289 10.2929C5.10536 10.4804 5 10.7348 5 11C5 11.2652 5.10536 11.5196 5.29289 11.7071C5.48043 11.8946 5.73478 12 6 12H7.058C6.98112 12.6645 6.98112 13.3355 7.058 14H6C5.73478 14 5.48043 14.1054 5.29289 14.2929C5.10536 14.4804 5 14.7348 5 15C5 15.2652 5.10536 15.5196 5.29289 15.7071C5.48043 15.8946 5.73478 16 6 16H7.545C8.644 18.903 11.292 21 14.471 21C16.533 21 18.388 20.106 19.727 18.686C19.8998 18.4916 19.9901 18.2376 19.9787 17.9777C19.9674 17.7179 19.8552 17.4727 19.666 17.2942C19.4768 17.1157 19.2256 17.0179 18.9655 17.0216C18.7054 17.0253 18.457 17.1302 18.273 17.314C17.278 18.368 15.936 19 14.47 19C12.481 19 10.687 17.813 9.729 16H14C14.2652 16 14.5196 15.8946 14.7071 15.7071C14.8946 15.5196 15 15.2652 15 15C15 14.7348 14.8946 14.4804 14.7071 14.2929C14.5196 14.1054 14.2652 14 14 14H9.075C8.97642 13.337 8.97642 12.663 9.075 12H14C14.2652 12 14.5196 11.8946 14.7071 11.7071C14.8946 11.5196 15 11.2652 15 11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10H9.73Z'
                    fill='#6F7281'
                  />
                </svg>{" "}
                ENTSOE Pricing Data Source
              </label>
            </div>
            <div className='field-body'>
              <div className='field'>
                <div
                  className='control is-expanded'
                  style={{ position: "relative" }}>
                  <div className='select is-fullwidth'>
                    <select
                      id='account-pricing-sel'
                      className='input load-control-input transparent-input pricing-sel'
                      disabled={!props.loaded}
                      value={entsoeSource}
                      onInput={(e) => setEntsoeSource(e.target.value)}>
                      <option value='no_price'>None</option>
                      <option value='germany'>Germany</option>
                      <option value='netherlands'>Netherlands</option>
                      <option value='belgium'>Belgium</option>
                    </select>
                  </div>
                  <button
                    id='account-pricing-sel-btn'
                    className='btn-small flex-it'
                    disabled={!props.loaded}
                    onClick={() =>
                      getFreshToken(
                        setLoadingSubmitPricing,
                        setSuccessSubmitPricing,
                        setErrorSubmitPricing,
                        "account",
                        handleSavePricing
                      )
                    }>
                    {loadingSubmitPricing ? (
                      <img
                        src={loadingIcon}
                        alt='loading'
                        style={{
                          display: "block",
                          transform: "scale(-1, 1)",
                        }}
                      />
                    ) : errorSubmitPricing ? (
                      <svg
                        width='23'
                        height='23'
                        viewBox='0 0 23 23'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M21 21L11.5 11.5M11.5 11.5L2 2M11.5 11.5L21 2M11.5 11.5L2 21'
                          stroke='#202B33'
                          stroke-width='3'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        />
                      </svg>
                    ) : successSubmitPricing ? (
                      <svg
                        width='26'
                        height='20'
                        viewBox='0 0 26 20'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M24.9699 1.18951C25.251 1.48821 25.402 1.88632 25.3896 2.2963C25.3772 2.70628 25.2025 3.09456 24.9039 3.37576L8.54828 18.7909C8.21487 19.1049 7.77182 19.2759 7.31391 19.2674C6.856 19.259 6.41959 19.0716 6.09803 18.7455L0.570529 13.1355C0.424155 12.9917 0.30786 12.8202 0.228416 12.631C0.148971 12.4418 0.107966 12.2387 0.107789 12.0335C0.107611 11.8283 0.148264 11.6251 0.227381 11.4357C0.306497 11.2464 0.422496 11.0747 0.56862 10.9306C0.714745 10.7865 0.888074 10.673 1.07851 10.5965C1.26895 10.5201 1.4727 10.4823 1.67788 10.4854C1.88306 10.4885 2.08558 10.5324 2.27364 10.6145C2.4617 10.6966 2.63154 10.8153 2.77328 10.9637L7.3809 15.6394L22.7837 1.12351C23.0824 0.842412 23.4805 0.691453 23.8904 0.70383C24.3004 0.716207 24.6887 0.890906 24.9699 1.18951Z'
                          fill='#202B33'
                        />
                      </svg>
                    ) : (
                      <svg
                        width='28'
                        height='30'
                        viewBox='0 0 28 30'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M3.18307 1.72152L25.5524 14.3051C25.6753 14.3747 25.7775 14.4757 25.8486 14.5977C25.9197 14.7198 25.9572 14.8585 25.9572 14.9997C25.9572 15.141 25.9197 15.2797 25.8486 15.4017C25.7775 15.5237 25.6753 15.6247 25.5524 15.6944L3.18306 28.2779C3.03966 28.3579 2.87506 28.3918 2.7117 28.3749C2.54834 28.358 2.39417 28.2911 2.2702 28.1834C2.14624 28.0756 2.05851 27.9323 2.01897 27.7729C1.97944 27.6135 1.99002 27.4458 2.04927 27.2926L6.7154 15.2887C6.7876 15.1028 6.7876 14.8966 6.7154 14.7107L2.04768 2.70681C1.98808 2.55344 1.97731 2.38541 2.01685 2.2257C2.05639 2.06598 2.14431 1.92239 2.26858 1.81455C2.39285 1.70671 2.54741 1.63989 2.7111 1.62324C2.87479 1.60659 3.03963 1.64091 3.18307 1.72152Z'
                          stroke='#202B33'
                          stroke-width='2.39534'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        />
                      </svg>
                    )}
                  </button>
                  <Overlay
                    target={copyTarget.current}
                    show={tooltipShow}
                    placement='top'>
                    {(props) => (
                      <Tooltip id='copy-tooltip' {...props}>
                        Copied!
                      </Tooltip>
                    )}
                  </Overlay>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
